
//Importaciones Angular
import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import { ApppRoutingModule } from './app.routing';
import { AppComponent } from './app.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FullComponent } from './layouts/full/full.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

//Importaciones Componentes base
import { AppHeaderComponent } from './layouts/full/header/header.component';
import { AppSidebarComponent } from './layouts/full/sidebar/sidebar.component';
import { SharedModule } from './shared/shared.module';
import { SpinnerComponent } from './shared/spinner.component';


//Angular Material
import { MatIconModule } from '@angular/material/icon';
import { ToastrModule } from 'ngx-toastr';
import { MaterialModule } from './material.module';
import { MatButtonModule, MatCardModule,MatFormFieldModule, MatInputModule, MatToolbarModule, MatTooltipModule } from '@angular/material';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material';
import {MatExpansionModule} from '@angular/material/expansion';

import { LoginComponent } from './login/login.component';
import { LoginDsaComponent } from './login/loginDSA/login-dsa.component';
import { LoginPostulanteComponent } from './login/loginPostulante/login-postulante.component';
import { CambioCredencialPostulanteComponent } from './login/loginPostulante/cambio-credencial-postulante/cambio-credencial-postulante.component';
import { CambioExitosoModalComponent } from './login/loginPostulante/cambio-credencial-postulante/cambio-exitoso-modal.component';
import { InterceptorService } from './services/interceptor.service';
import { NotFoundComponent } from './not-found/not-found.component';
import { FichaAdmisionComponent } from './public/ficha-admision/ficha-admision.component';
import {MatSelectModule} from '@angular/material/select';


import {MatStepperModule} from '@angular/material/stepper';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatDialogModule} from '@angular/material/dialog';
import { HomePageComponent } from './public/home-page/home-page.component';
import {MatMenuModule} from '@angular/material/menu';
import { OfertaAcademicaComponent } from './public/oferta-academica/oferta-academica.component';
import { ValidarDocumentoComponent } from './public/validar-documento/validar-documento.component';
import {MatListModule} from '@angular/material/list';
import { RouterModule } from '@angular/router';
// import { CambioCredencialComponent } from './modules/estudiante/cambio-credencial/cambio-credencial.component';

 
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    LoginDsaComponent,
    LoginPostulanteComponent,
    CambioCredencialPostulanteComponent,
    CambioExitosoModalComponent,
    FullComponent,
    AppHeaderComponent,
    SpinnerComponent,
    AppSidebarComponent,
    NotFoundComponent,
    FichaAdmisionComponent,
    HomePageComponent,
    OfertaAcademicaComponent,
    ValidarDocumentoComponent
    // CambioCredencialComponent
    

  ],
  imports: [
    BrowserModule,
    MatRadioModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    BrowserAnimationsModule,
    FormsModule,
    ToastrModule.forRoot(),
    FlexLayoutModule,
    HttpClientModule,
    SharedModule,
    ApppRoutingModule,
    MatIconModule,
    MatStepperModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatCardModule,
    MatSidenavModule,
    MatToolbarModule,
    MatDialogModule,
    MatMenuModule,
    MatListModule,
    RouterModule,
    MatExpansionModule,
    MatTooltipModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true
    }],

  bootstrap: [AppComponent],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AppModule {}
